// import node module libraries
import { Link } from 'react-router-dom';
import { Col, Row, Image } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

// import BS icons
import { Telephone, EnvelopeOpen, GeoAlt } from 'react-bootstrap-icons';

// import sub components
import ContactForm from './ContactForm';
import SEO from 'components/marketing/seo/Seo';

// import media files
import Logo from 'assets/images/brand/logo/logo.svg';

const Contact = () => {
	const { t } = useTranslation();

	return (
		<main>
			<SEO
				title="Kontakt"
				description="Du hast Fragen zu unseren Schnittstellen, Preisen oder Integrationen? Kontaktiere unser Team – wir helfen dir schnell & unkompliziert weiter."
				keywords="kontakt saas plattform, support multi channel e-commerce"
				canonical="https://haeppy.app/marketing/pages/contact/"
			/>
			<section className="container-fluid bg-white">
				<Row className="align-items-center min-vh-100">
					<Col lg={6} md={12} sm={12}>
						<div className="px-xl-20 px-md-8 px-4 py-8 py-lg-0">
							{/* content */}
							<div className="d-flex justify-content-between mb-7 align-items-center">
								<Link to="/">
									<Image src={Logo} width={250} alt="haeppy.app Logo" />
								</Link>
							</div>
							<div className="text-dark">
								<h1 className="display-4 fw-bold">{t('Contact Form')}</h1>
								<p className="lead text-dark">
									{t('For general inquiries, you can reach our team via this form.')}
								</p>
								<div className="mt-8">
									<p className="fs-4 mb-4">
										{t('Are you already a customer? For technical questions or problems, please use our')}{' '}
										<Link to="/marketing/help-center/">{t('Help Center')} <i className="fe fe-arrow-right"></i></Link>
									</p>
									{/* Address */}
									<p className="fs-4">
										<EnvelopeOpen size={16} className="text-primary me-2" />
										hello@haeppy-shopping.com
									</p>
									<p className="fs-4 ">
										<GeoAlt size={17} className="text-primary me-2" />
										Kopernikusstraße 14, 30167 Hannover
									</p>
								</div>
							</div>
						</div>
					</Col>

					{/* right side form section with background color */}
					<Col
						lg={6}
						className="d-lg-flex align-items-center w-lg-50 min-vh-lg-100 position-fixed-lg bg-cover bg-light top-0 right-0"
					>
						<ContactForm />
					</Col>
				</Row>
			</section>
		</main>
	);
};

export default Contact;